export const ONE_TIME_CELL_PIXELS = 18;
export const RECORD_MINUTES_SMALLEST_STEP = 5;
export const RECORD_MINUTES_SMALLEST_STEP_PIXELS = 6;
